import React from 'react';
import styled from 'styled-components';
import { FiX } from 'react-icons/fi';

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  position: relative;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin:15px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: -10px;
  right: -13px;
  background-color: #E75B82;
  border-radius: 30px;
  font-size: 20px;
  cursor: pointer;
  padding-top : 5px;
  color: white;
`;

const Image = styled.img`
  max-width: 100%;
  max-height: 80vh;
`;

const ImageModal = ({ imageUrl, onClose }) => {
  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <ModalBackground>
      <ModalContent onClick={stopPropagation}>
        <CloseButton onClick={onClose}>
          <FiX />
        </CloseButton>
        <Image src={imageUrl} alt="Original" />
      </ModalContent>
    </ModalBackground>
  );
};

export default ImageModal;
